module.exports = __webpack_public_path__ + "img/500px.23040ef6.svg";